import React from "react";
import Image from "@/bit/components/components.c-image";
import TextInfo from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import Price from "@/bit/components/components.price";
import DetailCardTitle from "@/bit/components/components.cms-block.cms-detail-card-title";

const DETAIL_CARD_CONTENT_TAGGING_INFO = {
  componentName: "DetailCard",
  componentVariation: "all",
};

const checkIfEmpty = (element) => {
  let res = true;
  if (element?.text || element?.price) {
    res = false;
  }

  return res;
};

const CardContent = ({ detailCardProps, cmsHandler }) => {
  const {
    imageSize,
    shadow,
    "cms-atom-price-1": detailCardPrice1,
    "cms-atom-price-2": detailCardPrice2,
    "cms-atom-button-1": detailCardButton1,
    "cms-atom-button-2": detailCardButton2,
    "cms-atom-image-1": detailCardImage1,
    "cms-atom-text-2": detailCardText2,
    "cms-atom-text-3": detailCardText3,
    "cms-atom-text-4": detailCardText4,
    "cms-ml-detail-card-title-1": detailCardTitle,
    loaded = true,
    className = "",
  } = detailCardProps;

  let taggingButton1 = {
    ...DETAIL_CARD_CONTENT_TAGGING_INFO,
    componentContent: detailCardButton1?.label || "Lo quiero",
    ...detailCardButton1?.taggingInfo,
  };

  let taggingButton2 = {
    ...DETAIL_CARD_CONTENT_TAGGING_INFO,
    componentContent: detailCardButton2?.label || "Ver detalle",
    ...detailCardButton2?.taggingInfo,
  };

  // Que haya un minimo de contenido de price
  const isPriceContentEmpty =
    [
      detailCardPrice1,
      detailCardPrice2,
      detailCardText3,
      detailCardText4,
    ].every(checkIfEmpty) && !cmsHandler;

  return (
    <div className={`card-content ${className}`}>
      {/* Velo imagenes */}
      {shadow && shadow !== "none" && (
        <div
          className={`shadow${shadow === "gradient" ? "-gradient" : ""}`}
        ></div>
      )}
      {detailCardImage1 && (detailCardImage1.src || cmsHandler) && (
        <div className={`image-gap${imageSize ? " size-" + imageSize : ""}`}>
          <Image {...detailCardImage1} cmsHandler={cmsHandler} />
        </div>
      )}
      <div
        className={`content${
          cmsHandler && imageSize && imageSize === "full"
            ? " content-resize"
            : ""
        }`}
      >
        {detailCardTitle && (
          <DetailCardTitle
            detailCardTitleProps={detailCardTitle}
            cmsHandler={cmsHandler}
          />
        )}
        <TextInfo
          {...detailCardText2}
          className="description-gap"
          cmsHandler={cmsHandler}
        />
        <div className="card-price-content">
          {!isPriceContentEmpty && (
            <div className="price-content">
              <TextInfo
                {...detailCardText3}
                className="pre-price"
                cmsHandler={cmsHandler}
              />
              <div className="price-inline">
                <Price {...detailCardPrice2} cmsHandler={cmsHandler} />
                <Price {...detailCardPrice1} cmsHandler={cmsHandler} />
              </div>
              <TextInfo
                {...detailCardText4}
                className="post-price"
                cmsHandler={cmsHandler}
              />
            </div>
          )}
          <div className="action-buttons">
            <Button
              {...detailCardButton1}
              taggingInfo={taggingButton1}
              cmsHandler={cmsHandler}
            />
            <Button
              {...detailCardButton2}
              taggingInfo={taggingButton2}
              cmsHandler={cmsHandler}
            />
          </div>
        </div>
      </div>
      <div className={loaded ? "skeleton loaded" : "skeleton"} />
      <style jsx>{`.card-content {
  display: flex;
  position:relative;
  flex-direction: column;
  background-color: #fff;
  min-width: 316px;
  width: min(20.9vw, 352px);
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #dddddd;
  
  &.inherited-card {
    filter: grayscale(50%) brightness(0.8);
  }

  .card-price-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: auto;
    position: relative;

    .price-inline {
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
  }

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 2;
    margin-top: auto;
    :global(.buttonx) {
      position: relative;
    }
  }
  .content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    flex: 1;
    // z-index: 2;

    &.content-resize {
      margin-top: 40px;
    }
    .content-price {
      display: flex;
      gap: 0.5rem;
    }
  }
  .image-gap {
    position: relative;
    min-height: 14.90rem;
    aspect-ratio: 4 / 3;
    width: 100%;
    &.size-small {
      min-height: 6rem;
      aspect-ratio: 13 / 3;
    }
    &.size-full {
      min-height: 100%;
      position: absolute;
    }
  }

  .shadow-gradient {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 33%, rgba(0, 0, 0, 0) 44%, rgba(0, 0, 0, 0) 100%);
  }
  .shadow {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.7);
  }

  .skeleton {
    position:absolute;
    display:block;
    &.loaded{
      display:none
    }
  }

  @media screen and (max-width: 1024px) {
    width: 20rem;
  }
}
`}</style>
    </div>
  );
};

export default CardContent;
